import { render, staticRenderFns } from "./uploaderText.vue?vue&type=template&id=f935a54e&scoped=true&"
import script from "./uploaderText.vue?vue&type=script&lang=ts&"
export * from "./uploaderText.vue?vue&type=script&lang=ts&"
import style0 from "./uploaderText.vue?vue&type=style&index=0&id=f935a54e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f935a54e",
  null
  
)

export default component.exports